export default "__VITE_ASSET__48ae2009__"